import React from 'react';
import { SvgProps } from './icon.types';

function PlusIcon({ fillColor = '#2D3049', width = 24, height = 24, ...rest }: SvgProps) {
  return (
    <svg height={height} viewBox="0 0 24 24" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs />
      <path d="M13 2v9h9v2h-9v9h-2v-9H2v-2h9V2z" fill={fillColor} fillRule="evenodd" />
    </svg>
  );
}

export { PlusIcon };
